import React from 'react';
import RemRoadmapComp from '../components/remRoadmap/RemRoadMapComp';
import RemTitle from '../components/remTitle/RemTitle';

function RemRoadmap() {
    return (
        <div>
            <RemTitle title='ROAD MAP FOR PUBLIC SALES' />
            <RemRoadmapComp />
        </div>
    );
}

export default RemRoadmap;